import React from 'react';
import { Box, Card, CardContent } from '@mui/material';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @Description Card with dynamic content and a button on the right side.
 * @param String id: Card identifier (required).
 * @param Boolean showButton:  Boolean variable to display button styles (optional).
 * @param {JSX.Element} children:  Elements that will be the content of the component (required).
 * @param event click:  Click event on the card (optional).
 * @param {JSX.Element} ButtonIcon it is the button component example: ButtonAction (optional).
 * @returns {JSX.Element}
 */
const CustomMiniCard = ({ id = 'ca-cmc-card', showButton = false, children, click, ButtonIcon }) => {

    return (
        <Card
            id={id}
            variant='outlined'
            className={`mini-card ${showButton ? 'default' : 'pointer'} mr-10px`}
            onClick={() => {
                if (click)
                    click();
            }}
        >
            <CardContent className='d-flex p-0'>
                <Box className={'py-2 px-3 w-100 p-a'}>
                    {children}
                </Box>

                {showButton &&
                    <div>
                        {ButtonIcon}
                    </div>
                }
            </CardContent>
        </Card>
    );
};

export default CustomMiniCard;
